import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./App.css";

function About() {

  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/home");
  };

  return (
    <div className="about-container">

      <Helmet>
        <title>About PRO AI Paragraph Generator | Free AI Writing Tool</title>

        <meta
          name="description"
          content="Learn about our AI Paragraph Generator – a free AI writing tool that helps students, bloggers, and writers instantly generate high-quality paragraphs for essays, blogs, and articles."
        />

        <meta
          name="keywords"
          content="Pro AI Paragraph Generator, paragraph generator in second, AI paragraph generator, easy-to-use AI writing tool, AI Easy Copy, artificial intelligence, free paragraph generator, paragraph generat in seconds, AI writing tool, Multi-Purpose paragraph generator, paragraph writing generator, AI content generator, content generator for bloggers, Unlimited Topics paragraph generator, paragraph maker, AI text generator"
        />

        <link rel="canonical" href="https://proaiparagraph.vercel.app/About" />

        <meta property="og:title" content="About AI Paragraph Generator" />
        <meta
          property="og:description"
          content="Discover how our AI Paragraph Generator helps create high-quality paragraphs instantly for blogs, essays, and articles."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://proaiparagraph.vercel.app/About" />
      </Helmet>

      <section className="about-hero">
        <h1>About PRO AI Paragraph Generator</h1>

        <p>
          Our <strong>PRO AI Paragraph Generator</strong> is a powerful and easy-to-use
          AI writing tool designed to help users quickly generate high-quality
          paragraphs on any topic.
        </p>
      </section>

      <button className="about-btn" onClick={goToHome} style={{marginLeft: "41.5%"}}>
        Generate Paragraph
      </button>

      <section className="about-section">

        <h2>Key Features</h2>

        <div className="about-grid">

          <div className="about-card">
            <h3>⚡ Fast Generation</h3>
            <p>Generate high-quality paragraphs instantly with AI.</p>
          </div>

          <div className="about-card">
            <h3>🧠 Smart AI</h3>
            <p>Advanced AI creates meaningful and human-like content.</p>
          </div>

          <div className="about-card">
            <h3>📄 Multi-Purpose</h3>
            <p>Useful for blogs, essays, assignments, and content writing.</p>
          </div>

          <div className="about-card">
            <h3>🆓 Free Tool</h3>
            <p>Use all features without any cost or subscription.</p>
          </div>

          <div className="about-card">
            <h3>📋 Easy Copy</h3>
            <p>Copy generated content with one click.</p>
          </div>

          <div className="about-card">
            <h3>🌍 Unlimited Topics</h3>
            <p>Create content on any topic anytime.</p>
          </div>

        </div>

      </section>

      {/* WHAT IS */}
      <section className="about-section">

        <h2>What is an PRO AI Paragraph Generator?</h2>

        <p>
          An <strong>PRO AI Paragraph Generator</strong> is an intelligent writing
          tool that uses artificial intelligence to automatically create
          paragraphs based on a topic or keyword.
        </p>

      </section>

      {/* HOW IT WORKS */}
      <section className="about-section">

        <h2>How Our PRO AI Paragraph Generator Works</h2>

        <div className="about-grid">

          <div className="about-card">
            <h3>1. Enter Topic</h3>
            <p>Type any keyword or subject.</p>
          </div>

          <div className="about-card">
            <h3>2. AI Writes</h3>
            <p>AI generates a meaningful paragraph instantly.</p>
          </div>

          <div className="about-card">
            <h3>3. Copy & Use</h3>
            <p>Use content anywhere you want.</p>
          </div>

        </div>

      </section>

      {/* WHY USE */}
      <section className="about-section">

        <h2>Why Use Our  PRO AI Paragraph Generator?</h2>

        <div className="about-grid">

          <div className="about-card">
            <h3>⏱ Save Time</h3>
            <p>Generate content quickly without effort.</p>
          </div>

          <div className="about-card">
            <h3>✍️ Improve Writing</h3>
            <p>Enhance your writing quality instantly.</p>
          </div>

          <div className="about-card">
            <h3>🚀 Boost Productivity</h3>
            <p>Create more content in less time.</p>
          </div>

        </div>

      </section>

    </div>
  );
}

export default About;